// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3b8319ac","239":"d5c7b2d6","453":"1003a1b8","455":"34ca375a"}[chunkId] + ".chunk.js";
};